import { FC } from 'react';
import { toGovernancePolicy } from '@agilelab/plugin-wb-governance';
import {
  TestStatus,
  useDrawersContext,
  WbTag,
} from '@agilelab/plugin-wb-platform';
import { TableCell, TableRow, Typography } from '@material-ui/core';
import { Task } from '../../ControlPanel';
import { useReleaseDetailPageContext } from '../context/useReleaseDetailPageContext';
import { useStyles } from './styles';
import { PolicyDetailDrawerContent } from '../../common';
import { PolicyGql } from '@agilelab/plugin-wb-governance-common';

interface Props {
  task: Task;
  policy: PolicyGql;
}

export const PolicyRow: FC<Props> = ({ task, policy }) => {
  const classes = useStyles();
  const { toggleBoolean } = useDrawersContext();
  const { setValidationTestResultDetailContent } =
    useReleaseDetailPageContext();
  const onRowClick = () => {
    setValidationTestResultDetailContent(
      <PolicyDetailDrawerContent
        task={task}
        policy={toGovernancePolicy(policy)}
      />,
    );
    toggleBoolean(1);
  };

  return (
    <TableRow onClick={onRowClick} className={classes.row}>
      <TableCell width="20%">
        <TestStatus
          status={task.status}
          filled
          severity={policy.content.severity}
          policyStatus={task.governanceEntityStatus}
        />
      </TableCell>
      <TableCell width="30%">
        <Typography style={{ fontWeight: 700 }}>
          {policy.name} - {policy.version}
        </Typography>
      </TableCell>
      <TableCell width="30%">
        <Typography>{policy.description}</Typography>
      </TableCell>
      <TableCell width="20%" align="right">
        <WbTag
          tag={{
            tagFQN: 'Policy',
          }}
        />
      </TableCell>
    </TableRow>
  );
};
